import forOwn from 'lodash.forown';
import isElement from 'lodash.iselement';
import isFunction from 'lodash.isfunction';
import isObject from 'lodash.isobject';

var deepFreeze = function deepFreeze(object) {
  return forOwn(Object.freeze(object), function (value) {
    if (value && value !== object && (isObject(value) || isFunction(value)) && !isElement(value) && !Object.isFrozen(value)) {
      deepFreeze(value);
    }
  });
};

export var freezer = function freezer(store) {
  return function (next) {
    return function (action) {
      var result = next(action);
      deepFreeze(store.getState());
      return result;
    };
  };
};